module.exports = __webpack_public_path__ + "static/media/ManjimupBridgetownTimes-socshare-min.da012978.jpg";